
const WelcomeNote = ({ onNext, data, readOnly }) => {


    return (
        <div className='d-flex justify-content-center'>
            <div className='welcome-note my-2'>
                <div>
                    <div className='text-center'>
                        <h4 className='company-name'>SRKAY Consulting Group Pvt. Ltd. </h4>
                        <h5 className='welcome-text my-2 mb-4'>Welcome Note</h5>
                    </div>
                    <div className='welcome-content my-4'>
                        <p>Dear <span className='text-decoration-underline'>{data?.employee?.user_display_name}</span> ,</p>
                        <h5 className='welcome-text'>Welcome aboard.</h5>
                    </div>
                    <div className='welcome-content'>
                        <p>We are excited, that you have accepted a position, with our growing company. We Congratulate and warmly welcome you, to SRKAY Consulting Group Pvt. Ltd. Family.</p>
                        <p>Our goal today, is to provide you with information, that will be a fulfilling career, <b>at SRKAY Consulting Group Pvt. Ltd.</b> We look forward to your contributions, to our organization and would like to ensure, that you are successful from day one.</p>
                        <p>We believe that the best-in-class talent, trained with the best-in-class tools, in the best-in-class environment, will create the best-in-class company. I welcome you, to be a part of this exciting journey, as you join SRKAY Consulting Group Pvt. Ltd.</p>
                        <p>Your Welcome Kit, is enclosed herewith and you are requested to go through the same and provide all necessary details/documents. The kit also contains details, on important things, you need to know and understand, as a new employee.</p>
                        <p className='py-4'>We wish you a successful career, with SRKAY Consulting Group Pvt. Ltd.</p>

                        <p>Yours Sincerely,</p>
                        <p>{data?.director}</p>
                        <p>Managing Director</p>
                    </div>

                </div>
                {
                    !readOnly && <div className='d-flex justify-content-end'>
                        <button className='btn-primary' onClick={onNext}>Proceed</button>
                    </div>
                }

            </div>
        </div>
    )
}

export default WelcomeNote